// extracted by mini-css-extract-plugin
module.exports = {"root":"Az38N","header":"_3Csu7","title":"DvgXK","thumbnailTitle":"_1DTLH","thumbnailLink":"_39X1z","thumbnailImg":"_2SeNb","thumbnailList":"_3ss5-","thumbnail":"_1479N"};